import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { setConfigurationListModal } from '../actions/generalActions'
import PropTypes from 'prop-types'

class ConfigurationListItem extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap() {
        this.props.Callback(this.props.Config);
    }

    render() {
        return (
                <button className="configurationListItem" onClick={evt => this.handleTouchTap(false)}>
                {this.props.Config.Description}
                <Ink />
                </button>
        )
    }
}

ConfigurationListItem.propTypes = {
    Callback: PropTypes.func
}
function mapStateToProps() {
    return {

    }
}

export default connect(mapStateToProps, { setConfigurationListModal })(ConfigurationListItem)


// WEBPACK FOOTER //
// src/components/ConfigurationListItem.jsx